import { NetworkError, ThrottleError } from './errors.js';

const MAX_RETRIES = 2;

/**
 * @aiPurpose React Query retry predicate for the web app's QueryClient.
 *   Retries transient network/server failures up to MAX_RETRIES, but
 *   excludes ThrottleError (HTTP 429) — retrying a throttled request
 *   immediately just amplifies the back-pressure @Throttle dampens.
 * @aiInvariant ApiClientError (4xx contract errors) and other non-network
 *   errors never retry. Plain NetworkError retries up to MAX_RETRIES.
 *   ThrottleError (subclass of NetworkError) never retries.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (!(error instanceof NetworkError)) return false;
  if (error instanceof ThrottleError) return false;
  return failureCount < MAX_RETRIES;
}
